import { render, staticRenderFns } from "./money_rank.vue?vue&type=template&id=83cfd188&scoped=true&"
import script from "./money_rank.vue?vue&type=script&lang=js&"
export * from "./money_rank.vue?vue&type=script&lang=js&"
import style0 from "./money_rank.vue?vue&type=style&index=0&lang=css&"
import style1 from "./money_rank.vue?vue&type=style&index=1&id=83cfd188&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83cfd188",
  null
  
)

export default component.exports